import { render, staticRenderFns } from "./PaymentTypeCreateDialog.vue?vue&type=template&id=08828512&scoped=true"
import script from "./PaymentTypeCreateDialog.vue?vue&type=script&lang=ts"
export * from "./PaymentTypeCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08828512",
  null
  
)

export default component.exports